import type { FaireThemeEntity } from "../../entity_types/theme";

export const spa_night_self_care: FaireThemeEntity = {
  token: "spa-night-self-care",
  type: "theme",
  retailerToken: "r_rk3595bqqg",
  name: "Spa Night Self-Care",
  description: "Bath and body products they gift and keep",
  bgColor: "#F0D4C4",
  tileBgColor: "#9e2d4b",
  productTokens: [
    "p_wqrmc65w4t",
    "p_drtm36ks59",
    "p_dd1ax8b7xy",
    "p_mgc4thfmq4",
    "p_5gay6r22jg",
    "p_enhx2t322u",
    "p_mb7pz63w34",
    "p_fp3axdhudg",
    "p_ynadzkkz7x",
    "p_gmrr38ewmf",
    "p_9gowjx571u",
    "p_7gmksayps6",
    "p_gby6j69z3q",
    "p_2g45nrqc7k",
    "p_wwcxm4h8x6",
    "p_ru4xgw4jpy",
    "p_8b2586npqq",
    "p_zwf5bbtdsv",
    "p_jfxp2rg4ey",
    "p_ntvymtr5tb",
    "p_ymvvfuynvw",
    "p_xnvpxb8uqn",
    "p_8kwzzxc9bw",
    "p_p8t6db595n",
    "p_52ghyvggxh",
    "p_8z8qtkmbja",
    "p_32tk8etdjy",
    "p_q5s2dmkfdd",
    "p_g98867ktgy",
    "p_8gxve2ml10",
    "p_28285brrrj",
    "p_bz143i56pw",
    "p_5xns4q656w",
    "p_gdydytg5fm",
    "p_wgamzu9wpv",
    "p_vy2pj2f29d",
    "p_rerfp7dvds",
    "p_jdh933mkzs",
    "p_j268csnvjg",
    "p_n3sxe78y4s",
    "p_a97qbqg7yq",
    "p_xcfjs5hzu7",
    "p_baarzszdv2",
    "p_3sf6fwh7nj",
    "p_s5trp6kcfk",
  ],
  exactProducts: true,
  meta: {
    source: "mock",
    importedAt: "2026-03-24T13:50:10Z",
    importedBy: "retailer-themes-entity-migration",
  },
};
